import React from 'react';
import { OverlayBackground } from './ModalOverlay.styles';

interface ModalOverlayProps {
  onClick: () => void;
}

const ModalOverlay = ({ onClick }: ModalOverlayProps): JSX.Element => (
  <OverlayBackground
    onClick={onClick}
    dataCy='overlay-background'
  />
);

export default ModalOverlay;
